import { render, staticRenderFns } from "./closeORaccountpage.vue?vue&type=template&id=117e38e0&scoped=true"
import script from "./closeORaccountpage.vue?vue&type=script&lang=js"
export * from "./closeORaccountpage.vue?vue&type=script&lang=js"
import style0 from "./closeORaccountpage.vue?vue&type=style&index=0&id=117e38e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e38e0",
  null
  
)

export default component.exports